import { FC } from "react";

import { GpsIndicatorCell } from "../../grid";
import { IRenderColumnTemplate } from "./_core";

export const GpsIndicatorCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
}) => {
  return <GpsIndicatorCell value={value} />;
};
